// icons
import { RiDeleteBin5Line } from "react-icons/ri";

const UploadedImages = (props) => {
  // props
  const { images, deleteImage } = props;

  // handlers
  const itemImageDeletedHandler = (index) => {
    deleteImage(index);
  };

  return (
    <section className="flex flex-col gap-2 items-center w-1/3">
      {images.map((image, index) => (
        <div
          key={index}
          className="w-full flex justify-between items-center border border-light-gray p-1 rounded"
        >
          <a href={image.imageUrl} target="_blank" rel="noreferrer">
            <img
              src={image.imageUrl}
              alt="item"
              className="w-14 h-14 object-center object-cover"
            />
          </a>
          <button
            className="border border-light-gray p-1"
            type="button"
            onClick={() => itemImageDeletedHandler(index)}
          >
            <RiDeleteBin5Line className="text-red-400" size={20} />
          </button>
        </div>
      ))}
    </section>
  );
};

export default UploadedImages;
